import React from 'react';
import styled, { keyframes } from 'styled-components';
import Button from '../common/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

const floatAnimation = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-15px); }
`;

const CtaWrapper = styled.section`
    padding: 120px 0;
    background: linear-gradient(135deg, ${({ theme }) => theme.colors.primary} 0%, ${({ theme }) => theme.colors.accent} 100%);
    color: ${({ theme }) => theme.colors.lighter};
    position: relative;
    overflow: hidden;
`;

const CtaBg = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
`;

const CtaCircle = styled.div`
    position: absolute;
    border-radius: 50%;
    filter: blur(60px);
    opacity: 0.2;
    background: ${({ theme }) => theme.colors.lighter};
    animation: ${floatAnimation} 8s ease-in-out infinite;

    &.circle-1 {
        width: 400px;
        height: 400px;
        top: -100px;
        left: -100px;
    }

    &.circle-2 {
        width: 300px;
        height: 300px;
        bottom: -50px;
        right: -50px;
        animation-duration: 6s;
        animation-delay: 2s;
    }
`;

const CtaContent = styled.div`
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
    position: relative;
    z-index: 1;

    h2 {
        font-size: 48px;
        font-weight: 800;
        margin-bottom: 24px;
        line-height: 1.2;
        @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
            font-size: 36px;
        }
    }

    p {
        font-size: 20px;
        opacity: 0.9;
        margin-bottom: 40px;
        line-height: 1.7;
        @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
            font-size: 18px;
        }
    }
`;

const CtaButton = styled.button`
    background: ${({ theme }) => theme.colors.lighter};
    color: ${({ theme }) => theme.colors.primary};
    padding: 18px 48px;
    border-radius: ${({ theme }) => theme.radii.md};
    font-weight: 800;
    display: inline-flex;
    align-items: center;
    gap: 12px;
    text-decoration: none;
    transition: ${({ theme }) => theme.transitions.default};
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    font-size: 18px;
    border: none;
    cursor: pointer;

    &:hover {
        transform: translateY(-5px) scale(1.05);
        box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
    }
`;

const CtaSection = () => {
    return (
        <CtaWrapper id="cta">
            <CtaBg>
                <CtaCircle className="circle-1" />
                <CtaCircle className="circle-2" />
            </CtaBg>
            <CtaContent>
                <h2>Pronto para consultar sua placa?</h2>
                <p>Não deixe para depois. Em menos de 1 minuto você pode descobrir informações que vão te proteger e ajudar a tomar a melhor decisão.</p>
                <CtaButton>
                    <FontAwesomeIcon icon={faSearch} /> Consultar Agora
                </CtaButton>
            </CtaContent>
        </CtaWrapper>
    );
};

export default CtaSection;